import { render, staticRenderFns } from "./aboutMembers.vue?vue&type=template&id=b228ec92&scoped=true&"
import script from "./aboutMembers.vue?vue&type=script&lang=js&"
export * from "./aboutMembers.vue?vue&type=script&lang=js&"
import style0 from "./aboutMembers.vue?vue&type=style&index=0&id=b228ec92&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b228ec92",
  null
  
)

export default component.exports